import type { U3400TileLogicalUnitCode } from '../U3400Service';

/**
 * Réordonne une liste de codes tuile (indices inclus).
 * Retourne le tableau d’origine si les indices sont invalides ou identiques.
 */
export function u3400ReorderTiles(
  tiles: U3400TileLogicalUnitCode[],
  fromIndex: number,
  toIndex: number,
): U3400TileLogicalUnitCode[] {
  if (
    fromIndex === toIndex ||
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= tiles.length ||
    toIndex >= tiles.length
  ) {
    return tiles;
  }
  const next = [...tiles];
  const [removed] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, removed);
  return next;
}

/**
 * Ajoute ou retire un code du brouillon Manager, en respectant maxTiles et l’unicité.
 */
export function u3400ToggleTileInDraft(
  draft: U3400TileLogicalUnitCode[],
  code: U3400TileLogicalUnitCode,
  checked: boolean,
  maxTiles: number,
): U3400TileLogicalUnitCode[] {
  if (checked) {
    if (draft.includes(code) || draft.length >= maxTiles) {
      return draft;
    }
    return [...draft, code];
  }
  return draft.filter((c) => c !== code);
}

/**
 * Déplace une tuile d’un cran dans le brouillon Manager (Monter / Descendre).
 */
export function u3400MoveTileInDraft(
  draft: U3400TileLogicalUnitCode[],
  index: number,
  direction: 'up' | 'down',
): U3400TileLogicalUnitCode[] {
  const target = direction === 'up' ? index - 1 : index + 1;
  return u3400ReorderTiles(draft, index, target);
}
